export const radomUUID = () => {
  const SLCommon = Mach.requireModule('SLCommon');
  const time = new Date().valueOf();
  return (SLCommon?.randomUUID?.() || '') + time;
};
